/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Model_StandardInputs */



/**
* | output |
* | --- |
* | "Standard" |
*
* @param {Assistant_Model_StandardInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_model_standard = /** @type {((inputs?: Assistant_Model_StandardInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Model_StandardInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Standard")
	if (locale === "de") return /** @type {LocalizedString} */ ("Standard")
	if (locale === "it") return /** @type {LocalizedString} */ ("Standard")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Стандарт")
	if (locale === "es") return /** @type {LocalizedString} */ ("Estándar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("标准")
	if (locale === "ja") return /** @type {LocalizedString} */ ("標準")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मानक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Padrão")
	return /** @type {LocalizedString} */ ("Standard")
});